import { render } from "./altertMessage.vue?vue&type=template&id=fc90ddac"
import script from "./altertMessage.vue?vue&type=script&lang=js"
export * from "./altertMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__